export default {
    cn: {
        companyTit: '公司与项目信息',
        name: '项目名称',
        companyName: '公司全称',
        companyWebsite: '公司网址',
        city: '所属城市',
        projectDirection: '项目方向',
        segmentation: '细分领域',
        projectBrief: "项目简介",
        projectBriefPlaceholder: '请简要介绍您的产品或服务，核心竞争力、市场状况、主要客户/竞争对手等内容，200字以内。',
        financingStatus: "融资状态",
        team: '团队介绍',
        teamName: '姓名',
        teamTitle: '职位',
        teamEdu: '教育背景',
        teamWork: '工作经历',
        bp: '商业计划书',
        selectFile: '选择文件',
        bpLimit: '仅限上传PDF类型的文件 (单个文件不超过20M)',
        support: '资源支持',
        supportPlaceholder: '希望奥迪提供的数据/资源',
        contact: '联系信息',
        contactName: "姓名",
        contactPhone: "手机",
        contactEmail: "邮箱",
        position: "职位（选填）",
        wechat: "微信（选填）",
        captcha: "验证码",
        choose: '请选择',
        submit: '点击提交资料'
    },
    en: {
        companyTit: 'Company and Project Information ',
        name: 'Project Name',
        companyName: 'Company Name',
        companyWebsite: 'Company Website',
        city: 'City',
        projectDirection: 'Project Direction',
        segmentation: 'Segmentation',
        projectBrief: "Project Brief",
        projectBriefPlaceholder: 'Please briefly describe your product or servive,core competencies,market size,major customers，competitors and other content,less than 200words。',
        financingStatus: "Financing Status",
        team: 'Team Introduction',
        teamName: 'Name',
        teamTitle: 'Title',
        teamEdu: 'Educational Background',
        teamWork: 'Work Experience',
        bp: 'BP(Business plan/proposal)',
        selectFile: 'Select File',
        bpLimit: 'Only upload PDF type of file (a single file does not exceed 20M)',
        support: 'Resource Support',
        supportPlaceholder: 'Resource/data support by Audi',
        contact: 'Contact Information',
        contactName: "Contact Name",
        contactPhone: "Contact Phone",
        contactEmail: "Contact Email",
        position: "Title",
        wechat: "Wechat",
        captcha: "Verification Code",
        choose: 'Please Choose',
        submit: 'Click to submit'
    }
}